import { initialised } from "../initialised";
import calculateNotifyMeDetails from "./calculateNotifyMeDetails";

export const initialisedForBackInStock = state => {
  const newState = calculateNotifyMeDetails({ state });

  return initialised(newState);
};
